var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 338,
    viewBox: "0 0 600 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M599.8 0.300049H-0.200012V337.6H599.8V0.300049Z",
    fill: "#DE4437"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M355.2 131.5C380.108 131.5 400.3 123.352 400.3 113.3C400.3 103.248 380.108 95.1 355.2 95.1C330.292 95.1 310.1 103.248 310.1 113.3C310.1 123.352 330.292 131.5 355.2 131.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M393.9 121.5C416.212 121.5 434.3 103.412 434.3 81.0999C434.3 58.7876 416.212 40.7 393.9 40.7C371.588 40.7 353.5 58.7876 353.5 81.0999C353.5 103.412 371.588 121.5 393.9 121.5Z",
    fill: "#EE4A57"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.8 420.5C105.24 420.5 159.1 366.64 159.1 300.2C159.1 233.76 105.24 179.9 38.8 179.9C-27.6399 179.9 -81.5 233.76 -81.5 300.2C-81.5 366.64 -27.6399 420.5 38.8 420.5Z",
    fill: "#1AE8C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 337.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card-3.2ab9200cfd9922b02e32d63eb4aecafe.svg";
export { ForwardRef as ReactComponent };